import React from 'react'
import styled from 'styled-components'
import LogosResponsiveCarousel from './LogosResponsiveCarousel'
import Cookies from 'universal-cookie'
import { gaEvents } from '../analytics/events'
import { withAuth } from './AuthContext'
import { Link, withRouter } from 'react-router-dom'
import {
  Container,
  ContainerFlexColumn,
  ContainerFlexRow,
  Image,
  Title,
  CustomSubtitle,
  ActionButtons,
  BackOutline,
} from './Utils/CustomClasses'
import Paypal from './Dashboard/Paypal'
import { shouldTranslateTo } from '../utils/utils'
import { logosLink } from './Homepage'
import { getCurrencySign } from '../utils/utils'

const cookies = new Cookies()

const ContainerFlexColumnForm = styled(ContainerFlexColumn)`
  text-align: center;
`

const CustomContainer = styled(Container)`
  background-color: #f3f4f6;
  padding: 30px;

  @media screen and (max-width: 768px) {
    padding: 30px 10px;
  }
`

const Box = styled.div`
  background-color: #fff;
`

const HeaderContainer = styled(Container)`
  padding: 40px;
  margin-top: 0;
  @media screen and (max-width: 768px) {
    padding: 20px;
  }
`

const LineBreak = styled.hr`
  width: 40vw;
  min-width: 400px;
  border-top: 1px solid rgba(0, 0, 0, 0.24);
  margin: 30px auto;

  @media screen and (max-width: 768px) {
    width: -webkit-fill-available !important;
    min-width: unset !important;
  }
`

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: center;
  justify-content: center;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`

const Center = styled.div`
  text-align: center;
  margin-top: 140px;
`

const CustomContainerFlexRow = styled(ContainerFlexRow)`
  flex-wrap: wrap;
`

const CardBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 20%;
  min-width: 200px;

  gap: 45px;

  padding: 40px 20px;
  border-radius: 15px;
  border: 1px solid #e8e8e8;

  background: #fff;
  box-shadow: 0px 4px 9px 0px rgba(0, 0, 0, 0.08);

  img {
    width: 80px;
  }
`

const CustomCardBox = styled(CardBox)`
  flex-basis: 30%;
  min-width: 210px;
  max-width: 310px;
`

const Logos = styled.div`
  background-color: #f8f9f9;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5vh 0;
  ${(props) => props.padding && `padding: ${props.padding}`};

  @media screen and (max-width: 1025px) {
    ${(props) => props.paddingMd && `padding: ${props.paddingMd}`};
  }

  @media screen and (max-width: 768px) {
    ${(props) => props.paddingSm && `padding: ${props.paddingSm}`};
  }
`

const ContainerFlexRowWrap = styled(ContainerFlexRow)`
  @media screen and (max-width: 1025px) {
    flex-direction: row;
  }
  @media screen and (max-width: 890px) {
    flex-direction: column;
  }
`

const ImagePaypalResponsive = styled.img`
  content: url('/images/icons/licensePaypal.svg');

  @media screen and (max-width: 768px) {
    content: url('/images/icons/licensePaypal-mobile.svg');
  }
`

function GiftYourPaymentChoice(props) {
  const [pageText, setPageText] = React.useState([])
  const [checkout, setCheckout] = React.useState(false)
  const [membershipFee, setMembershipFee] = React.useState(59)
  const [currencySign, setCurrencySign] = React.useState('')
  const [membershipFeeStatus, setMembershipFeeStatus] =
    React.useState('pending')

  React.useEffect(() => {
    console.log('use-effect')
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue, setPageState) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageState(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    const getCurrency = async () => {
      const currencyValue =
        cookies.get('cV') != '' && cookies.get('cV') != null
          ? cookies.get('cV')
          : 'EUR'

      const data = await getCurrencySign(currencyValue)
      setCurrencySign(data.sign)
      console.log('data.sign: ' + data.sign)
    }

    getPageText('select-gift-payment', language, setPageText)
    getCurrency()
  }, [])

  const auth = props.auth
  const { history } = props

  const userStorage = JSON.parse(localStorage.getItem('ud'))

  console.log('auth.user: ' + JSON.stringify(auth.user))

  const CardCustom = ({ image, text }) => {
    return (
      <CustomCardBox>
        <img src={image} />
        <Title
          size="21px"
          sizemd="21px"
          sizesm="21px"
          center
          dangerouslySetInnerHTML={{ __html: `${text}` }}
        />
      </CustomCardBox>
    )
  }

  const PaypalGiftPayment = () => {
    gaEvents.eventGeneric(
      'button_click',
      'paypal-chosen',
      userStorage.id + '(GIFT) - choose membership fee - button - choose Paypal'
    )

    setMembershipFeeStatus('pending')
    setCheckout(true)
    window.scrollTo(0, 0)
  }

  const StripeGiftPayment = () => {
    const userData = {
      membershipFee: membershipFee,
    }

    props.auth.updateUser(userData).then(() => {
      gaEvents.eventGeneric(
        'button_click',
        'stripe-chosen',
        userStorage.id +
          '(GIFT) - choose membership fee - button - choose Stripe'
      )

      setMembershipFeeStatus('pending')
      history.push('/gift-your-grown-up/pay-by-cc')
    })
  }

  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }
  return (
    <CustomContainer>
      <Box>
        <HeaderContainer>
          <BackOutline padding="4px 20px">
            <Link onClick={() => props.history.go(-1)}>{pageText[0]}</Link>
          </BackOutline>
          <ContainerFlexColumnForm center padding="80px 0" paddingSm="30px 0">
            {checkout ? (
              <div>
                <div>
                  <Paypal
                    user={userStorage}
                    membershipFee={membershipFee}
                    currencySign={auth.user.currencyValue}
                    isFromGift={true}
                    isDev={false}
                  />
                </div>
                <div className="text-center" style={{ marginTop: '15px' }}>
                  <button
                    type="button"
                    className="btn btn-danger text-decoration-none"
                    onClick={() => {
                      setCheckout(false)
                    }}
                  >
                    Back
                  </button>
                </div>
              </div>
            ) : (
              <div>
                <CustomSubtitle
                  size="22px"
                  sizemd="22px"
                  sizesm="17px"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[1]}`,
                  }}
                />
                <LineBreak margin="30px 0 90px 0" />
                <Title
                  center
                  smCenter
                  size="30px"
                  sizemd="25px"
                  sizesm="22px"
                  margin="0 0 70px 0"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[2]}`,
                  }}
                />
                <CustomSubtitle
                  size="22px"
                  sizemd="22px"
                  sizesm="17px"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[3].replace(
                      '{{feeData}}',
                      currencySign + membershipFee
                    )}`,
                  }}
                />
                <LineBreak margin="60px 0" />
                <FlexRow>
                  <ActionButtons onClick={(e) => StripeGiftPayment()}>
                    <img src="/images/icons/card.svg" /> {pageText[4]}
                  </ActionButtons>
                  <ActionButtons
                    blackText
                    background="#FCBB32"
                    onClick={(e) => PaypalGiftPayment()}
                  >
                    {pageText[5]} <img src="/images/icons/paypal.svg" />
                  </ActionButtons>
                </FlexRow>
                <Center>
                  <ImagePaypalResponsive />
                </Center>
              </div>
            )}
          </ContainerFlexColumnForm>
        </HeaderContainer>
        {/* Cards 2 */}
        <ContainerFlexColumn
          center
          padding="12vh 15vw 12vh 15vw"
          paddingMd="7vh 30px 5vh 30px;"
          paddingSm="6vh 5vw 6vh 5vw"
          background="#F2E8D8"
        >
          <Title
            center
            smCenter
            size="35px"
            margin="0 auto 40px auto"
            dangerouslySetInnerHTML={{ __html: `${pageText[6]}` }}
          ></Title>
          <CustomContainerFlexRow center gap="40px" gapMd="30px" rowMd>
            <CardCustom
              image="/images/select-gift-payment/1.svg"
              text={pageText[7]}
            />
            <CardCustom
              image="/images/select-gift-payment/2.svg"
              text={pageText[8]}
            />
            <CardCustom
              image="/images/select-gift-payment/3.svg"
              text={pageText[9]}
            />
            <CardCustom
              image="/images/select-gift-payment/4.svg"
              text={pageText[10]}
            />
            <CardCustom
              image="/images/select-gift-payment/3.svg"
              text={pageText[11]}
            />
            <CardCustom
              image="/images/select-gift-payment/4.svg"
              text={pageText[12]}
            />
          </CustomContainerFlexRow>
        </ContainerFlexColumn>
        {/* Empower */}
        <ContainerFlexRowWrap
          gray
          gap="80px"
          gapMd="40px"
          padding="10vh 3vw 10vh 3vw"
          paddingMd="7vh 30px 5vh 30px"
          paddingSm="4vh 10vw"
          background="#FFF"
          center
        >
          <Image width="30vw" widthMd="40vw">
            <img src="/images/select-gift-payment/people.svg" />
          </Image>
          <ContainerFlexColumn center>
            <Title
              size="39px"
              sizemd="30px"
              sizesm="30px"
              centerMd
              dangerouslySetInnerHTML={{
                __html: `${pageText[13]}`,
              }}
            ></Title>
          </ContainerFlexColumn>
        </ContainerFlexRowWrap>
        {/* LOGOS */}
        <Logos padding="10vh 7vw 10vh 7vw" paddingSm="3vh 7vw 3vh 7vw">
          <Title
            center
            size="38px"
            sizemd="38px"
            sizesm="30px"
            margin="0 0 30px 0"
            smCenter
            dangerouslySetInnerHTML={{
              __html: `${pageText[14]}`,
            }}
          ></Title>
          <LogosResponsiveCarousel logosLink={logosLink} />
        </Logos>
      </Box>
    </CustomContainer>
  )
}

export default withRouter(withAuth(GiftYourPaymentChoice))
